import { useEffect, useState } from "react";
import api from "../../../utils/axiosInstance";
import SystemValueTable, { VendorCodeCell } from "./SystemValueTable";

const columns = [
  {
    header: "Vendor",
    render: (row) => (
      <VendorCodeCell vendorId={row.vendor?.id || row.vendor_id} />
    ),
  },
  { header: "Service", render: (row) => row.service?.name || "—" },
];

const ServicesPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/vendor-services", { withCredentials: true });
        setRows(res.data.data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch services");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading)
    return <div className="text-center mt-10 text-gray-500">Loading...</div>;
  if (error)
    return <div className="text-center mt-10 text-danger-600">{error}</div>;

  return (
    <div className="space-y-5">
      <h1 className="text-[22px] font-semibold tracking-tight text-gray-900">Services</h1>
      <p className="text-sm text-gray-600">
        Showing <span className="font-semibold">{rows.length}</span> items.
      </p>
      <SystemValueTable
        columns={columns}
        rows={rows}
        emptyText="No vendor services found."
      />
    </div>
  );
};

export default ServicesPage;
